export default {"src":"/_next/static/media/D.f84c67e6.svg","height":18,"width":18};